import "./CaseStudy7ElevenRewards.scss";
import { useEffect, useRef, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import MediaBlock from "../MediaBlock/MediaBlock";
import BigDivider from "../BigDivider/BigDivider";
import useStore from "../../store";
import BigDivider7Eleven from "../BigDivider7Eleven/BigDivider7Eleven";
import Robot7Eleven from "../Robot7Eleven/Robot7Eleven";
import ImageRow from "../ImageRow/ImageRow";
import MediaTitleTextBlock from "../MediaTitleTextBlock/MediaTitleTextBlock";
import RoundedDivider from "../RoundedDivider/RoundedDivider";
import MediaBlock7Eleven from "../MediaBlock7Eleven/MediaBlock7Eleven";
import Quotes from "../Quotes/Quotes";

function CaseStudy7ElevenRewards(props) {
  const activeCaseStudy = useStore((state) => state.activeCaseStudy);

  const tl = useRef();
  const el = useRef();

  const sectionStart = useRef();
  const sectionEnd = useRef();

  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    //console.log("active Case Study", activeCaseStudy);
    if (tl.current) tl.current.pause();
    // console.log("activeCaseStudy", activeCaseStudy, props.index);
    tl.current = gsap.timeline({
      onComplete: () => {
        ScrollTrigger.refresh();
      },
    });
    if (activeCaseStudy === null) {
      tl.current.call(() => {
        document.body.classList.remove("greyBackground");
      });
    }

    if (activeCaseStudy === props.index) {
      tl.current.call(() => {
        document.body.classList.add("greyBackground");
      });
      tl.current.to([el.current], {
        height: "auto",
        overflow: "unset",
        ease: "circ.in",
        duration: 0,
      });
      tl.current.to(props.el.current, {
        duration: 0.0,
        scrollTo: el.current.offsetTop - (window.innerHeight / 100) * 36,
        ease: "Power1.easeInOut",
      });
    } else {
      //tl.current.set([el.current], { height: "0" });
      if (
        el.current.offsetHeight > 0 &&
        props.el.current.scrollTop > el.current.offsetTop
      ) {
        tl.current.set(
          props.el.current,
          {
            scrollTo: props.el.current.scrollTop - el.current.offsetHeight,
          },
          0
        );
        tl.current.set(
          el.current,
          {
            height: 0,
            overflow: "hidden",
          },
          0
        );
      } else {
        tl.current.to(
          [el.current],
          {
            height: 0,
            ease: "circ.out",
            duration: 0.5,
            overflow: "hidden",
            // delay: 0.5,
          },
          0
        );
      }
    }
  }, [activeCaseStudy]);

  // useEffect(() => {
  //   if (isActive && props.index === activeCaseStudy) {
  //     document.body.classList.add("greyBackground");
  //   } else {
  //     document.body.classList.remove("greyBackground");
  //   }
  // }, [isActive]);

  // useEffect(() => {
  //   ScrollTrigger.create({
  //     scroller: props.el.current,
  //     // markers: true,
  //     trigger: sectionStart.current,
  //     start: "top 22%",
  //     endTrigger: sectionEnd.current,
  //     end: "bottom top",
  //     invalidateOnRefresh: true,
  //     onToggle: (self) => {
  //       // console.log("toggled, isActive:", self.isActive);
  //       setIsActive(self.isActive);
  //     },
  //     onUpdate: (self) => {
  //       //console.log("progress:", self.progress.toFixed(3));
  //       //setProgress(parseFloat(self.progress.toFixed(3)));
  //     },
  //   });
  // }, []);

  return (
    <div
      id={"case-study-" + props.data.id}
      ref={el}
      className={`case-study-7-eleven-rewards`}
    >
      <div ref={sectionStart} className="section-start"></div>
      <MediaBlock
        data={props.data.blocks[0]}
        section={props.data.title}
        count={1}
        color={"white"}
        background={"beige"}
        style={"full-bleed"}
        hideSectionLabels={true}
        total={props.data.blocks.length + 1}
      />
      <BigDivider7Eleven
        data={props.data.blocks[1]}
        background={"pink"}
        color={"black"}
      />
      <Robot7Eleven data={props.data.blocks[3]} />
      <MediaBlock
        data={props.data.blocks[2]}
        section={props.data.title}
        count={2}
        color={"white"}
        background={""}
        style={"tight full-bleed"}
        hideSectionLabels={true}
        total={props.data.blocks.length + 1}
      />
      <BigDivider7Eleven
        data={props.data.blocks[4]}
        background={"pink"}
        color={"black"}
      />
      <ImageRow data={props.data.blocks[5]} />
      <Robot7Eleven data={props.data.blocks[3]} />
      <MediaTitleTextBlock
        data={props.data.blocks[6]}
        section={props.data.title}
        count={3}
        color={"black"}
        background={"red7Eleven"}
        total={props.data.blocks.length + 1}
      />
      <MediaBlock
        data={props.data.blocks[7]}
        section={props.data.title}
        count={4}
        color={"black"}
        background={"beige"}
        style={"tight offset-top-big inset-80"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <BigDivider7Eleven
        data={props.data.blocks[8]}
        background={"green7Eleven"}
        color={"black"}
      />
      <MediaBlock
        data={props.data.blocks[9]}
        section={props.data.title}
        count={5}
        color={"black"}
        background={"green7Eleven"}
        style={"tight offset-top"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <RoundedDivider
        data={props.data.blocks[10]}
        background={"white"}
        color={"black"}
      />
      <ImageRow data={props.data.blocks[11]} />
      <MediaBlock7Eleven
        data={props.data.blocks[12]}
        section={props.data.title}
        count={6}
        color={"black"}
        background={"redOrange"}
        style={"tight offset-top-big inset-80"}
        hideSectionLabels={false}
        total={props.data.blocks.length + 1}
      />
      <RoundedDivider
        data={props.data.blocks[13]}
        background={"white"}
        color={"black"}
      />
      <ImageRow data={props.data.blocks[14]} />
      <MediaTitleTextBlock
        data={props.data.blocks[15]}
        section={props.data.title}
        count={7}
        color={"black"}
        background={"blue7Eleven"}
        total={props.data.blocks.length + 1}
      />
      <ImageRow data={props.data.blocks[16]} />
      <BigDivider7Eleven
        data={props.data.blocks[17]}
        background={"blue7Eleven"}
        color={"black"}
      />
      <ImageRow data={props.data.blocks[18]} />
      <BigDivider7Eleven
        data={props.data.blocks[19]}
        background={"blue7Eleven"}
        color={"black"}
      />
      <MediaTitleTextBlock
        data={props.data.blocks[20]}
        section={props.data.title}
        count={8}
        color={"black"}
        background={"pink2"}
        total={props.data.blocks.length + 1}
      />
      <Quotes
        data={props.data.blocks[21]}
        background={"beige"}
        color={"black"}
        highlight={"red7Eleven"}
        count={9}
        total={props.data.blocks.length + 1}
      />
      <div ref={sectionEnd} className="section-end"></div>
    </div>
  );
}

export default CaseStudy7ElevenRewards;
